export default __webpack_public_path__ + "static/media/roboto-latin-100.c2aa4ab1.woff2";